import { PencilSimple } from '@phosphor-icons/react';
import { t } from 'i18next';

import { TextLine } from 'core/elements';
import { getPercentage } from 'core/utils';
import { PricingHelper } from 'pricing/helpers';
import { Color } from 'theme/enums';

interface IProps {
  price: number;
  computedCost: number;
  color?: Color;
  onClick?: () => void;
  editable?: boolean;
  label?: string;
}

const getMarginValueToDisplay = (margin: number, editableMargin: boolean, label?: string) => {
  if (margin != null) {
    return label
      ? `${label}: ${getPercentage(margin)}`
      : t('labelMarginWithValue', {
          value: getPercentage(margin),
        });
  }

  if (editableMargin) {
    return <PencilSimple />;
  }

  return '';
};

const Margin = ({
  price,
  computedCost,
  color = Color.PRIMARY,
  onClick,
  editable = false,
  label,
}: IProps) => {
  const margin = computedCost && price ? PricingHelper.computeGpm(computedCost, price) : null;

  return (
    <TextLine
      text={getMarginValueToDisplay(margin, editable, label)}
      color={color}
      onClick={editable ? onClick : undefined}
      sx={{ display: 'flex', justifyContent: 'flex-end', minWidth: '100px', textWrap: 'nowrap' }}
      isSubText
    />
  );
};

export default Margin;
